import { render, staticRenderFns } from "./GradeItem.vue?vue&type=template&id=5ea65690&"
import script from "./GradeItem.vue?vue&type=script&lang=ts&"
export * from "./GradeItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports